export default {
  First: -1,
  Item: 1,
  Power: 2,
  SpellStart: 100,
  AlwaysActivePower: 999,
};
